"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _require = require('bson'),
  ObjectId = _require.ObjectId;
var _ = require('lodash');
module.exports = /*@ngInject*/function ($resource, $q, $window, ConfigService, LokiService, MOBILE) {
  var _ConfigService$getCon = ConfigService.getConfig(),
    INSPECT_URL = _ConfigService$getCon.INSPECT_URL;
  var service = $resource("".concat(INSPECT_URL, "/api/party"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/party/:id")
    },
    _get: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/party/:id")
    },
    getPartiesByProgram: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/party/all/program"),
      isArray: 1
    },
    findParty: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/party/:id")
    },
    updatePartyMember: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/party/:id/member/:action")
    },
    getLocationsFromServer: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/party/:collection/location/:locationId"),
      params: {
        buildingId: '@buildingId',
        floorId: '@floorId',
        roomId: '@roomId'
      },
      isArray: true,
      cache: false
    },
    getPeopleFromServer: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/party/:partyId/member/:partyMemberId/people")
    },
    getPeopleFromServerPublic: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/public/report/:shareableToken/party/:partyId/member/:partyMemberId/people")
    },
    getPeopleByPartyMemberAndSource: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/party/partypeople/source/:sourceId/party/:partyId"),
      isArray: true
    },
    getPartyPeopleBySource: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/party/partypeople/source/:sourceId")
    },
    updatePartyPeople: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/party/partypeople/:partyPeopleId/mapping/action/:action")
    },
    getAllPartyTypes: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/party/types"),
      isArray: true
    }
  });
  service.get = function (options, cb) {
    if (MOBILE) {
      return LokiService.collection('party').then(function (collection) {
        var result = collection.findOne({
          _id: options.id
        });
        return cb ? cb(result) : result;
      });
    }
    return cb ? service._get(options, cb) : service._get(options);
  };
  service.getPeople = function (options, cb) {
    if (MOBILE) {
      return LokiService.collection('partyToPeople').then(function (collection) {
        var _collection$findOne = collection.findOne({
            _id: options.partyToPeopleId
          }),
          mappings = _collection$findOne.mappings;
        var result = [];
        mappings.forEach(function (mapping) {
          mapping.parties.forEach(function (party) {
            if (party.id === options.partyMemberId && party.type === options.type) {
              result.push(mapping);
            }
          });
        });
        return cb ? cb(result) : result;
      });
    }
    service.getPeopleFromServer({
      partyMemberId: options.partyMemberId,
      partyId: options.partyId
    }).$promise.then(function (result) {
      return cb ? cb(result) : result;
    });
  };
  service.getPeoplePublic = function (options, cb) {
    service.getPeopleFromServerPublic({
      partyMemberId: options.partyMemberId,
      partyId: options.partyId,
      shareableToken: options.shareableToken
    }).$promise.then(function (result) {
      return cb ? cb(result) : result;
    });
  };
  service.getLocations = function (options, cb) {
    if (MOBILE) {
      if (options.partyToLocationId) {
        return LokiService.collection('partyToLocation').then(function (collection) {
          var match = collection.findOne({
            _id: options.partyToLocationId
          });
          var matchMapping = match.mappings.find(function (mapping) {
            return mapping.id === options.party.id;
          });
          var locations = matchMapping ? matchMapping.locations : [];
          return cb ? cb(locations) : locations;
        });
      }
      if (options.locationId) {
        return LokiService.collection('location').then(function (collection) {
          var locations = collection.chain().where(function (member) {
            var locationBuildingFilter = member.reference.buildingId === options.party.reference.buildingId && member.reference.location === options.locationId;
            var floorFilter = member.reference.floorId === options.party.reference.floorId;
            var roomFilter = member.reference.roomId === options.party.reference.roomId;
            if (options.party.reference.roomId) {
              return roomFilter;
            }
            if (options.party.reference.floorId) {
              return floorFilter;
            }
            return locationBuildingFilter;
          }).simplesort('name').data();
          return cb ? cb(locations) : locations;
        });
      }
    } else if (options.partyToLocationId) {
      service.getLocationsFromServer({
        collection: 'partyToLocation',
        locationId: options.partyToLocationId
      }).$promise.then(function (result) {
        var matchLocation = result[0].mappings.find(function (mapping) {
          return mapping.id === options.party.id;
        });
        var locations = matchLocation ? matchLocation.locations : null;
        return cb ? cb(locations) : locations;
      });
    } else if (options.locationId) {
      if (options.party.reference.buildingId || options.party.reference.floorId || options.party.reference.roomId) {
        service.getLocationsFromServer({
          collection: 'location',
          locationId: options.locationId,
          buildingId: options.party.reference.buildingId,
          floorId: options.party.reference.floorId,
          roomId: options.party.reference.roomId
        }).$promise.then(function (result) {
          var locations = _.sortBy(result, [function (location) {
            return location.name.toLowerCase();
          }], ['name']);
          return cb ? cb(locations) : locations;
        });
      }
    }
  };
  service.mergePartyLocations = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(configuration, party) {
      var partyToLocation, mappings;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!configuration.partyToLocation) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return service.getLocationsFromServer({
              collection: 'partyToLocation',
              locationId: configuration.partyToLocation
            }).$promise;
          case 3:
            partyToLocation = _context.sent;
            mappings = partyToLocation[0].mappings;
            party.members.forEach(function (member) {
              var mapping = mappings.find(function (locationMapping) {
                return locationMapping.id === member.id;
              });
              if (mapping) {
                var locationMap = {};
                mapping.locations.forEach(function (location) {
                  if (location.buildingName) {
                    if (!locationMap[location.buildingName]) {
                      locationMap[location.buildingName] = {
                        buildingName: location.buildingName,
                        rooms: []
                      };
                    }
                    locationMap[location.buildingName].rooms.push(location.roomNumber);
                  }
                });

                // eslint-disable-next-line no-param-reassign
                member.location = Object.values(locationMap).reduce(function (locations, location) {
                  return locations.concat("".concat(location.buildingName, " (").concat(location.rooms.join(', '), ")"));
                }, []).join(', ');
              }
            });
          case 6:
            return _context.abrupt("return", party);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  service.initializePartyMember = function () {
    return {
      id: new ObjectId().toString(),
      name: null,
      description: null,
      reference: {
        id: null,
        buildingId: null,
        floorId: null
      },
      parent: null,
      active: true,
      attributes: []
    };
  };
  return service;
};